import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {CycleCountPage} from './cycle-count';
import {TranslateModule} from "@ngx-translate/core";
import {CycleCountService} from "../../providers/cyclecount.service";
import {RoundProgressModule} from "angular-svg-round-progressbar";
import {VirtualScrollModule} from "angular2-virtual-scroll";
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {CycleCountDetailPage} from "./cycle-count.detail";
import {PipesModule} from '../../pipes/pipes.module';
import {CycleCountFiltersModal} from './cycle-count.filters.modal';
import {DynamicSelectComponentModule} from '../../components/dynamic-select/dynamic-select.module';
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';
import {NoResultsComponentModule} from "../../components/no-results/no-results.module";

@NgModule({
  declarations: [
    CycleCountPage,
    CycleCountDetailPage,
    CycleCountFiltersModal,
  ],
  imports: [
    HeaderTitleComponentModule,
    IonicPageModule.forChild(CycleCountPage),
    TranslateModule.forChild(),
    RoundProgressModule,
    VirtualScrollModule,
    InfiniteScrollModule,
    PipesModule,
    NoResultsComponentModule,
    DynamicSelectComponentModule,
  ],
  providers: [
    CycleCountService
  ],
  entryComponents: [
    CycleCountDetailPage,
    CycleCountFiltersModal
  ]
})
export class CycleCountPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/cycle-count/cycle-count.module.ts